module.exports = __webpack_public_path__ + "static/media/buying-or-selling-a-home-articles.15095f7d.jpg";